import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';

import Header from 'components/Header';
import CreateBudget from 'components/CreateBudget';
import ScriptImportModal from 'components/ScriptImportModal';
import BudgetImportModal from 'components/BudgetImportModal';
import EditBudget from 'components/EditBudget';
import AddFolder from 'components/AddFolder';
import { useAppContext } from 'contexts/AppContext';
import { useHomeScreenContext } from './contexts/HomeScreenContext';
import DeleteBudget from 'components/DeleteBudget';
import ShareBudget from 'components/ShareBudget';
import BudgetSettings from 'components/BudgetSettings';
import SaveBudgetAsTemplate from 'components/SaveBudgetAsTemplate';
import CostReportModal from 'components/CostReportModal';

import './styles.scss';
import DeleteFringes from 'components/DeleteFringe';
import DeleteGroup from 'components/DeleteGroup';
import CornerSpinner from 'components/CornerSpinner';

const HomeScreenLayout = () => {
  const { userData, userProfile } = useAppContext();
  const [loading, setLoading] = useState(false);
  const {
    menuActions,
    showCreateBudget,
    showDeleteBudget,
    showDeleteFringe, //fringe
    showCreateFolder,
    showShareBudget,
    menuPermissions,
    showBudgetSettings,
    showSaveAsTemplate,
    showCostReport,
    showScriptImport,
    showBudgetImport,
    hideBudgetImportModal,
    budgetList,
    selectTab,
    showDeleteGroup,
    showEditBudget,
  } = useHomeScreenContext();

  const handleLoader = value => {
    setLoading(value);
  };

  return (
    <div className="home-screen-wrapper">
      <Header
        menuActions={menuActions}
        menuPermissions={menuPermissions}
        userData={
          userData
            ? {
                ...userData,
                profile_image: userProfile?.userprofile?.profile_image,
                name: userProfile?.name,
              }
            : {}
        }
        budgetList={budgetList}
        selectTab={selectTab}
        handleLoader={handleLoader}
      />
      <main className="main-container ps-5 pt-2">
        {loading ? (
          <CornerSpinner isLoading size="md" label="Loading workspace" />
        ) : (
          <Outlet />
        )}
      </main>
      {showCreateBudget && <CreateBudget />}
      {showScriptImport && <ScriptImportModal />}
      {showBudgetImport && (
        <BudgetImportModal
          show={showBudgetImport}
          onHide={hideBudgetImportModal}
        />
      )}
      {showEditBudget && <EditBudget />}
      {showCreateFolder && <AddFolder />}
      {/* {showDeleteMultiBudgets && <DeleteMultiBudgets />} */}

      {showDeleteFringe && <DeleteFringes />}
      {showDeleteGroup && <DeleteGroup />}
      {showDeleteBudget && <DeleteBudget />}
      {showShareBudget && <ShareBudget />}
      {showBudgetSettings && <BudgetSettings />}
      {showSaveAsTemplate && <SaveBudgetAsTemplate />}
      {showCostReport && <CostReportModal />}
    </div>
  );
};

export default HomeScreenLayout;
